export default __webpack_public_path__ + "static/media/89.350051a8.png";